import { LoadingBar, LoadingContext, PopupAppHeader, useLoadingContext } from '@kinetic-ui/shared';
import { Box } from '@mui/material';
import { Route, Switch } from 'react-router-dom';
import { CreateLocation } from '~/locations/createLocation/CreateLocation';
import { SelectSignals } from '~/signals/selectSignals/SelectSignals';
import { CREATE_LOCATION_ACTION_ROUTE, SELECT_SIGNALS_ACTION_ROUTE } from './constants';
import { getActionRoute } from './getActionRoute';

export const ActionsRouter = () => {
  const loadingContext = useLoadingContext();

  return (
    <LoadingContext.Provider value={loadingContext}>
      <Box display='flex' flexDirection='column' width={'100%'}>
        <Box>
          <PopupAppHeader />
          <LoadingBar absolute />
        </Box>

        <Switch>
          <Route path={getActionRoute(SELECT_SIGNALS_ACTION_ROUTE)}>
            <SelectSignals />
          </Route>
          <Route path={`${getActionRoute(CREATE_LOCATION_ACTION_ROUTE)}/:defaultLocationType?`}>
            <CreateLocation />
          </Route>
        </Switch>
      </Box>
    </LoadingContext.Provider>
  );
};
